// src/components/LegalLayout.jsx
// Composant de mise en page commun pour toutes les pages légales
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const LegalLayout = ({ children, title }) => {
  const location = useLocation();
  
  // Liste des pages légales pour la navigation
  const legalPages = [
    { path: '/faq', label: 'FAQ' },
    { path: '/cgv', label: 'CGV' },
    { path: '/cgu', label: 'CGU' },
    { path: '/mentions-legales', label: 'Mentions légales' },
    { path: '/confidentialite', label: 'Confidentialité' }
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="mb-8">
        <Link 
          to="/" 
          className="flex items-center hover:opacity-80 transition-all"
          style={{ color: '#87A96B' }}
        >
          ← Retour à l'accueil
        </Link>
        
        <h1 className="text-3xl font-bold mt-4 mb-6" style={{ color: '#2C3E50' }}>{title}</h1>
        
        {/* Navigation entre les pages légales */}
        <div className="flex flex-wrap gap-2 border-b border-gray-200 pb-4 mb-6">
          {legalPages.map((page) => (
            <Link
              key={page.path}
              to={page.path}
              className={`px-4 py-2 rounded-full transition-all ${
                location.pathname === page.path
                  ? 'text-white'
                  : 'bg-gray-100 hover:bg-gray-200'
              }`}
              style={location.pathname === page.path 
                ? { backgroundColor: '#87A96B' } 
                : { color: '#2C3E50' }
              }
            >
              {page.label}
            </Link>
          ))}
        </div>
      </div>
      
      <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100">
        {children}
      </div>
      
      <div className="mt-8 text-center text-sm" style={{ color: '#6c757d' }}>
        <p>© {new Date().getFullYear()} MealPlannerAI. Tous droits réservés.</p>
        <p className="mt-1">
          Ces documents ont été mis à jour le 22 avril 2025.
        </p>
      </div>
    </div>
  );
};

export default LegalLayout;